module.exports = __webpack_public_path__ + "img/bankch.24f66690.png";